export default "__VITE_ASSET__a3bd7cfc__"